export default {
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  SET_ROLE_INFOS(state, roleInfos) {
    state.roleInfos = roleInfos
  },
  ADD_ROLE(state, role) {
    state.roles.unshift(role)
  },
  UPDATE_ROLE(state, role) {
    const roleIndex = state.roles.findIndex((w) => w.id === role.id)
    Object.assign(state.roles[roleIndex], role)
  },
  DELETE_ROLE(state, roleId) {
    const ItemIndex = state.roles.findIndex((w) => w.id === roleId)
    state.roles.splice(ItemIndex, 1)
  },
}
